import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './assets/css/style.css';
import TaskPopup from './components/TaskPopup';
import { Provider } from 'react-redux';
import store from './state/store';

ReactDOM.render(
    <Provider store = {store}>
        <App />
    </Provider>, 
    document.querySelector("#chkr-checklist-manager")
);
